import { render, staticRenderFns } from "./SortOneManyPreview.vue?vue&type=template&id=fa3c3838&lang=pug&"
import script from "./SortOneManyPreview.vue?vue&type=script&lang=js&"
export * from "./SortOneManyPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports